module.exports = __webpack_public_path__ + "img/loca_coffee_bg.d20f8e35.png";